module.exports = __webpack_public_path__ + "img/red.ff0e91d9.svg";